export default {
    _prefix: "FormEditorSidePanel.EvaluationAssistance",
    labels: {
        heading: "Evaluation Assistance",
        assistanceIcon: "Evaluation Assistance",
        questions: "questions",
        question: "question",
        condition: "condition",
        conditions: "conditions",
    },
    summary: (data: {
        questionsConfiguredWithAssistance: number;
        totalQuestionCount: number;
        entity: string;
    }) => {
        return "{{questionsConfiguredWithAssistance}} of {{totalQuestionCount}} {{entity}} configured";
    },
    invalidConditions: (data: {
        invalidConditions: number;
        entity: string;
    }) => {
        return "{{invalidConditions}} invalid {{entity}}";
    },
};
